import React from "react";

const Quote = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
    >
      <path
        d="M15.3 0L13 4C14.1 4 15.0417 4.39167 15.825 5.175C16.6083 5.95833 17 6.9 17 8C17 9.1 16.6083 10.0417 15.825 10.825C15.0417 11.6083 14.1 12 13 12C11.9 12 10.9583 11.6083 10.175 10.825C9.39167 10.0417 9 9.1 9 8C9 7.61667 9.04583 7.2625 9.1375 6.9375C9.22917 6.6125 9.36667 6.3 9.55 6L13 0H15.3ZM6.3 0L4 4C5.1 4 6.04167 4.39167 6.825 5.175C7.60833 5.95833 8 6.9 8 8C8 9.1 7.60833 10.0417 6.825 10.825C6.04167 11.6083 5.1 12 4 12C2.9 12 1.95833 11.6083 1.175 10.825C0.391666 10.0417 0 9.1 0 8C0 7.61667 0.0458336 7.2625 0.137499 6.9375C0.229166 6.6125 0.366667 6.3 0.549999 6L4 0H6.3ZM11.9375 6.9375C11.6458 7.22917 11.5 7.58333 11.5 8C11.5 8.41667 11.6458 8.77083 11.9375 9.0625C12.2292 9.35417 12.5833 9.5 13 9.5C13.4167 9.5 13.7708 9.35417 14.0625 9.0625C14.3542 8.77083 14.5 8.41667 14.5 8C14.5 7.58333 14.3542 7.22917 14.0625 6.9375C13.7708 6.64583 13.4167 6.5 13 6.5C12.5833 6.5 12.2292 6.64583 11.9375 6.9375ZM2.9375 6.9375C2.64583 7.22917 2.5 7.58333 2.5 8C2.5 8.41667 2.64583 8.77083 2.9375 9.0625C3.22917 9.35417 3.58333 9.5 4 9.5C4.41667 9.5 4.77083 9.35417 5.0625 9.0625C5.35417 8.77083 5.5 8.41667 5.5 8C5.5 7.58333 5.35417 7.22917 5.0625 6.9375C4.77083 6.64583 4.41667 6.5 4 6.5C3.58333 6.5 3.22917 6.64583 2.9375 6.9375Z"
        fill="#207C97"
        fillOpacity="0.23"
      />
    </svg>
  );
};

export default Quote;
